import { Label } from "@/components/ui/label";
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@/components/ui/select";
import {
  hrubkyDosiekSlotu,
  type DostupnaHrubka,
} from "@/api/hooks/useDostupneHrubky";

/**
 * Výber hrúbky dosiek podľa materiálu slotu (KOLO 168) — Korpus Builder,
 * Dvere aj Zásuvka. Jeden komponent, aby tri okná neponúkali tri rôzne
 * zoznamy; čo v ňom je, rozhoduje `hrubkyDosiekSlotu`.
 */
export function HrubkaDoskySelect({
  value,
  onChange,
  matZ,
  hrubky,
  label,
  ariaLabel,
  labelClassName,
  triggerClassName,
}: {
  value: string;
  onChange: (v: string) => void;
  /** Hrúbka plošného materiálu slotu (`hrubkaMaterialu`), null = bez neho. */
  matZ: number | null;
  /** Hrúbky z Nastavení (`useDostupneHrubky`). */
  hrubky: DostupnaHrubka[];
  label: string;
  ariaLabel: string;
  labelClassName?: string;
  triggerClassName?: string;
}): JSX.Element {
  const aktualna = parseFloat(value);
  const moznosti = hrubkyDosiekSlotu(
    hrubky,
    matZ,
    Number.isFinite(aktualna) ? aktualna : null,
  );
  return (
    <div>
      <Label className={labelClassName}>{label}</Label>
      <Select value={value} onValueChange={onChange}>
        <SelectTrigger className={triggerClassName} aria-label={ariaLabel}>
          <SelectValue />
        </SelectTrigger>
        <SelectContent>
          {moznosti.map((mm) => (
            <SelectItem key={mm} value={String(mm)}>
              {mm} mm
            </SelectItem>
          ))}
        </SelectContent>
      </Select>
    </div>
  );
}
